import { createSelector } from '@reduxjs/toolkit';
import { Submission, SUBMISSION_STATUS } from '../models/submission';
import { User } from '../models/user';
import { SubmissionFilter } from '../store/admin';
import { AppState, submissionSelector } from '../store/store';


export const selectSubmissions = createSelector([
    (state: AppState) => submissionSelector.selectAll(state),
    (_state: AppState, archived: boolean) => archived
], (subissions: Submission[], archived: boolean) => subissions.filter(p => archived == !!p.archived).sort((a, b) => { return b.created?.localeCompare(a.created ?? '') ?? 0; }));

export const selectAllSubmissions = createSelector([
    (state: AppState, archives: boolean) => selectSubmissions(state, archives),
    (state: AppState) => state.admin.submissionFilter,
    (state: AppState) => state.device.user,
    (_: AppState, archives?: boolean) => archives
], (submissions: Submission[], filter: SubmissionFilter, user?: User, archives?: boolean) => {

    const franchiseId = user?.franchiseId;
    let arr = submissions;
    const status: any[] = [];
    if (filter.mySubmissions && franchiseId) {
        arr = arr.filter(p => {
            return (p.franchiseId == null || franchiseId === null || franchiseId == p.franchiseId);
        });
    }

    if (archives === true) {
        return arr;
    }

    if (filter.accepted) status.push(SUBMISSION_STATUS.ACCEPTE);
    if (filter.enCours) status.push(SUBMISSION_STATUS.EN_COURS);
    if (filter.refuse) status.push(SUBMISSION_STATUS.REFUSE);


    return arr.filter(p => p.status == null || status.indexOf(p.status) !== -1);

});
